import { motion } from "framer-motion"
import { useState } from "react"
import { AssignBillElementType } from "../../../types"
import { defaultTransactionStatus } from "../../../../../data/defaultValues"
import { formatCurrency, returnThousanderBreakInNumber } from "../../../../../services/functions"

export function AssignBillElement(props: AssignBillElementType) {
    const [check, setcheck] = useState(false)

    return (
        <div className="w-full relative h-fit">
            <motion.div
                initial={{
                    height: "2.5rem",
                    backgroundColor: "#fff",
                }}
                animate={{
                    height: check ? "9rem" : "2.5rem",
                    backgroundColor: check ? "#f2f5f8" : "#fff",
                }}
                transition={{
                    duration: 0.1,
                    type: "ease",
                }}
                className="z-10  flex flex-col w-full px-4 relative border-b cursor-pointer bg-white overflow-hidden"
                onClick={() => setcheck(!check)}>
                <div className="flex flex-row gap-2 items-center py-2 relative hover:bg-gray-100">
                    <div className="w-14 text-xs">{props.date}</div>
                    <div
                        className={`w-32 text-right font-bold text-sm ${
                            props.information.processingStatus === defaultTransactionStatus.ASSIGNED
                                ? "text-green-600"
                                : props.information.processingStatus === defaultTransactionStatus.IGNORE
                                ? "text-gray-400"
                                : "text-black"
                        }`}>
                        {formatCurrency(props.information.paymentInformation?.transactionAmount?.amount?.valueOf() ?? 0)}
                    </div>
                    <div className={`w-full pl-2 pr-8 text-sm ${check ? "text-gray-100" : "text-gray-400"}`}>
                        <p className="line-clamp-1">{props.information.paymentInformation?.remittanceText}</p>
                    </div>
                    <div className="w-full absolute top-12 flex flex-col text-sm max-h-24 overflow-y-auto pb-2">
                        <div className="flex flex-col sm:flex-row gap-2">
                            {/* ATTENDEES */}
                            <p className="sm:w-40">
                                <span className="underline">Beteiligte:</span>
                                {props.information.paymentInformation.counterpartNames.map((item: string) => (
                                    <span>
                                        <br />
                                        {item}
                                    </span>
                                ))}
                            </p>
                            {/* VERWENDUNGSZWECK */}
                            <p className="sm:px-8">
                                <span className="underline">Verwendungszweck:</span> <br />
                                {props.information.paymentInformation.remittanceText}
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-2 pt-2">
                            <p className="sm:w-40">
                                <span className="underline">Verbrauchter Betrag:</span> <br />
                                {returnThousanderBreakInNumber(
                                    props.information.assignmentHistory
                                        .filter((element: any) => element.action === "assign")
                                        .reduce((sum: number, element: any) => sum + element.amount, 0) -
                                        props.information.assignmentHistory
                                            .filter((element: any) => element.action === "unassign")
                                            .reduce((sum: number, element: any) => sum + element.amount, 0)
                                )}{" "}
                                €
                            </p>
                            <p className="sm:px-8">
                                <span className="underline">Wieviel Zahlungsanforderungen zugeordnet:</span>
                                <br />
                                {props.information.assignmentHistory.map((item: any) => item.action === "assign").length -
                                    props.information.assignmentHistory.map((item: any) => item.action === "unassign").length}
                            </p>
                        </div>
                    </div>
                    {check && (
                        <>
                            <button
                                className="hidden sm:block btn btn-primary btn-outline btn-sm absolute bottom-0 right-8"
                                disabled={props.alreadyAssignedToPayreq}
                                onClick={() => {
                                    if (props.alreadyIgnored) {
                                        props.unassignTransaction()
                                    } else {
                                        props.ignoreTransaction()
                                    }
                                    setcheck(false)
                                }}>
                                {props.alreadyIgnored ? "Ignorieren rückgängig machen" : "Zahlung ignorieren"}
                            </button>
                            {!props.alreadyIgnored && (
                                <button
                                    className="btn btn-primary btn-sm absolute bottom-0 right-0 sm:right-56"
                                    onClick={() => {
                                        if (props.alreadyAssignedToPayreq) {
                                            props.unassignTransaction()
                                        } else {
                                            props.assignTransaction()
                                        }
                                        setcheck(false)
                                    }}>
                                    {props.alreadyAssignedToPayreq ? "Zuordnung entfernen" : "Zuordnen"}
                                </button>
                            )}
                        </>
                    )}
                </div>
            </motion.div>
        </div>
    )
}
